<script>
  import ClickOut from '../../../../utils/directives/clickout'
  export default{
    name: 'btn-controle',
    props: ['leilao', 'ACL', 'currentUser'],
    data () {
      return {
        open: false
      }
    },
    computed: {
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{ open: open}"  v-click-out="hide">
    <button class="btn btn-sm btn-black" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle"><i class="fa fa-window-maximize m-r-xs"></i> Controle <span class="m-l-sm caret"></span></button>
    <ul class="dropdown-menu no-padder">
      <li>
        <router-link :to="{name: 'leilao.monitor-comitente', params: {leilao: leilao.id}}" tabindex="2"><i class="fa fa-history fa-fw"></i> Acompanhamento Comitente</router-link>
      </li>
      <li v-if="ACL.check('controlar_leilao', currentUser.id)">
        <router-link :to="{name: 'pregao', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-gamepad fa-fw"></i> Controle do Leilão</router-link>
      </li>
      <li>
        <router-link :to="{name: 'pregaoleiloeiro', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-drivers-license fa-fw"></i> Tela Leiloeiro</router-link>
      </li>
      <li>
        <!--<router-link :to="{name: 'pregaolance', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-desktop fa-fw"></i> TV Lance v1</router-link>-->
        <a style="opacity: 0.5" target="_blank" :href="'https://www.consorciorioparkingcarioca.com/leiloes/' + leilao.id + '/?pregoeiro=1'" tabindex="2"><i class="fa fa-desktop fa-fw"></i> Apresentação Telão Antigo</a>
        <router-link :to="{name: 'apresentacao-lotes', params: {id: leilao.id},}" tabindex="2"><i class="fa fa-desktop fa-fw"></i> Apresentação Telão</router-link>
      </li>
      <li>
        <a target="_blank" :href="'https://lotes.consorciorioparkingcarioca.com/#/?leilao=' + leilao.id" tabindex="2"><i class="fa fa-sliders fa-fw"></i> Apresentação Lotes</a>
      </li>
      <li>
        <router-link :to="{name: 'pregaolance2', params: {id: leilao.id}, query: {version: 2}}" tabindex="2"><i class="fa fa-desktop fa-fw"></i> TV Lance</router-link>
      </li>
      <li>
        <router-link :to="{name: 'pregaolance-cronometro', params: {id: leilao.id}, query: {version: 2}}" tabindex="2"><i class="fa fa-desktop fa-fw"></i> TV Lance Leiloeiro</router-link>
      </li>
      <li>
        <router-link :to="{name: 'pregaoleiloeiropatio', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-desktop fa-fw"></i> Auxílio Pátio</router-link>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// BtnControle.vue?e49baef8